import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-[#2C2F48] py-4 text-white customContainer flex justify-center '>
      <a href="https://github.com/ksalpern" target='_blank'>
        <img src="/assets/github-icon.svg" alt="click here to see my github" />
      </a>
    </footer>
  )
}

export default Footer
